<template>
  <div class="main-category">
    <MainCategoryHeader
      v-if="hasSubCategoryFilter"
      :title="mainTitle"
      :options="subCategoryList.itemList"
      :default="'장르'"
      @on-click-back="goToBack"
    />

    <WCatalog :catalog="catalogData" class="home-catalog" />
  </div>
</template>

<script setup>
  import { ref, computed, watch, reactive } from 'vue'
  import { useRoute, useRouter } from 'vue-router/composables'
  import { useHome } from '@/common/use/useHome'
  import { PATH_NAME_HOME } from '@/common/router.const'
  import MainCategoryHeader from '@/components/category/Main/Header'

  import WCatalog from '@/views/home/WCatalog.vue'

  const { getCategoryMainData } = useHome()
  const route = useRoute()
  const router = useRouter()

  const catalogData = ref({})
  const categoryData = ref({})
  const id = ref('')

  const mainTitle = ref('')
  const subList = ref(null)
  const subCategoryList = reactive({
    _default: '',
    itemList: [],
  })

  const mainCode = computed(() => route?.query.mainCode?.toUpperCase() ?? '')
  const hasSubCategoryFilter = computed(
    () => (subCategoryList.itemList.length ?? 0) > 0,
  )

  watch(route, ({ query }) => {
    if (query.mainCode) {
      init()
    }
  })

  const goToBack = () => {
    router.push({ name: PATH_NAME_HOME })
  }

  const setFilterValues = () => {
    const mainHome = {
      adult: 'n',
      title: `${mainTitle.value} 홈`,
      value: mainCode.value,
    }

    subCategoryList._default = subList.value[0].title
    subCategoryList.itemList = [mainHome, ...subList.value]
  }

  const setInitialFilter = (category) => {
    const current = category.categoryList?.find(
      (cate) => cate.code === mainCode.value,
    )

    mainTitle.value = current.elementList[0]?.property?.text
    subList.value = current.subList.map((sub) => {
      return {
        adult: 'n',
        title: sub.elementList[0].property.text,
        value: sub.code,
      }
    })
  }

  const setCategoryMain = async () => {
    const data = await getCategoryMainData({ category: mainCode.value })

    if (data) {
      const { catalog, category } = data?.layout
      catalogData.value = catalog ?? {}
      categoryData.value = category ?? {}
      id.value = data?.id ?? ''
    }
  }

  const init = async () => {
    await setCategoryMain()
    setInitialFilter(categoryData.value)
    setFilterValues()
  }

  init()
</script>
